"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubPage = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var Dialog_1 = require("office-ui-fabric-react/lib/Dialog");
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
var config_1 = require("../config");
var hooks_1 = require("../shared/hooks");
var AiHubLoadingState_1 = require("../shared/AiHubLoadingState");
var demo_auth_context_1 = require("../shared/auth/demo-auth-context");
var dashboard_utils_1 = require("../Dashboard/utils/dashboard-utils");
var ai_hub_route_utils_1 = require("../shared/utils/ai-hub-route-utils");
require("./styles/ai-hub-page.scss");
require("./styles/ai-hub-button-utilities.scss");
// Route-level code splitting: heavy sub-trees (Admin, Dashboard, UseCaseDetails)
// are loaded on demand to keep the initial bundle small. Named exports are
// re-mapped to default exports for React.lazy.
var WsAiHubAdmin = react_1.lazy(function () {
    return Promise.resolve().then(function () { return __importStar(require('../Admin/Admin')); }).then(function (m) { return ({ default: m.WsAiHubAdmin }); });
});
var WsAiHubDashboard = react_1.lazy(function () {
    return Promise.resolve().then(function () { return __importStar(require('../Dashboard/Dashboard')); }).then(function (m) { return ({
        default: m.WsAiHubDashboard,
    }); });
});
var WsAiHubUseCaseDetails = react_1.lazy(function () {
    return Promise.resolve().then(function () { return __importStar(require('../UseCaseDetails/UseCaseDetails')); }).then(function (m) { return ({
        default: m.WsAiHubUseCaseDetails,
    }); });
});
var USE_CASES_ENDPOINT = '/ai/ukdc/use-cases';
var ACTIVE_IMPORT_RUN_ENDPOINT = '/ai/ukdc/import/runs/active';
var USE_CASE_DETAILS_ROUTE = '/deliver/ai/use-cases/:useCaseId';
var AI_HUB_ROUTE = '/deliver/ai';
var loadUseCases = function () { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, config_1.getApiGet()(USE_CASES_ENDPOINT)];
            case 1:
                result = _a.sent();
                if (result && Array.isArray(result)) {
                    return [2 /*return*/, dashboard_utils_1.mapUseCasesWithStage(result)];
                }
                return [2 /*return*/, []];
        }
    });
}); };
var loadActiveImportRun = function () { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, config_1.getApiGet()(ACTIVE_IMPORT_RUN_ENDPOINT)];
            case 1:
                result = _a.sent();
                if (!result || typeof result !== 'object') {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, result];
        }
    });
}); };
var isActiveImportStatus = function (status) {
    if (!status) {
        return false;
    }
    return status === 'queued' || status === 'running';
};
var formatImportDateTime = function (value) {
    if (!value) {
        return '-';
    }
    var parsedDate = new Date(value);
    if (Number.isNaN(parsedDate.getTime())) {
        return value;
    }
    return parsedDate.toLocaleString();
};
var formatImportRunLabel = function (value) {
    if (!value) {
        return '-';
    }
    var normalisedValue = value
        .trim()
        .replace(/[-_]+/g, ' ')
        .replace(/\s+/g, ' ');
    if (!normalisedValue) {
        return '-';
    }
    return normalisedValue
        .split(' ')
        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); })
        .join(' ');
};
var WsAiHubPage = function (props) {
    var history = react_router_dom_1.useHistory();
    var location = react_router_dom_1.useLocation();
    var initialTab = ai_hub_route_utils_1.getAiHubTab(location.pathname, location.search);
    var _a = react_1.useState(initialTab), tab = _a[0], setTab = _a[1];
    var _b = react_1.useState(null), activeImportRun = _b[0], setActiveImportRun = _b[1];
    var _c = react_1.useState(false), isImportDetailsOpen = _c[0], setIsImportDetailsOpen = _c[1];
    var isUseCaseDetailsPath = ai_hub_route_utils_1.isAiHubUseCaseDetailsPath(location.pathname);
    var shouldLoadUseCases = tab === 'dashboard' || isUseCaseDetailsPath;
    var _d = hooks_1.useAsyncData({
        initialData: null,
        load: loadUseCases,
        enabled: shouldLoadUseCases,
    }), useCases = _d.data, isLoadingUseCases = _d.isLoading, reloadUseCases = _d.reload, useCasesError = _d.error;
    var handleRefreshUseCases = react_1.useCallback(function () {
        void reloadUseCases();
    }, [reloadUseCases]);
    var refreshActiveImportRun = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var run, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, loadActiveImportRun()];
                case 1:
                    run = _b.sent();
                    setActiveImportRun(run);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    setActiveImportRun(null);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    react_1.useEffect(function () {
        void refreshActiveImportRun();
    }, [refreshActiveImportRun]);
    // Keep tab state in sync with URL, normalising the location when needed.
    react_1.useEffect(function () {
        var normalizedLocation = ai_hub_route_utils_1.normalizeAiHubLocation(location.pathname, location.search);
        if (normalizedLocation !== "" + location.pathname + location.search) {
            history.replace(normalizedLocation);
            return;
        }
        setTab(ai_hub_route_utils_1.getAiHubTab(location.pathname, location.search));
    }, [location.pathname, location.search, history]);
    var updateTabInUrl = react_1.useCallback(function (newTab) {
        history.push(ai_hub_route_utils_1.buildAiHubTabPath(location.pathname, location.search, newTab === 'admin' ? 'admin' : 'dashboard'));
        setTab(newTab);
    }, [history, location.pathname, location.search]);
    var activeUseCaseId = ai_hub_route_utils_1.getAiHubUseCaseId(location.pathname);
    var activeUseCase = react_1.useMemo(function () {
        var _a;
        return activeUseCaseId
            ? ((_a = useCases === null || useCases === void 0 ? void 0 : useCases.find(function (useCase) { return useCase.id === activeUseCaseId; })) !== null && _a !== void 0 ? _a : null)
            : null;
    }, [activeUseCaseId, useCases]);
    var handleUseCasesTabClick = react_1.useCallback(function (event) {
        event.preventDefault();
        if (activeUseCase) {
            history.push(ai_hub_route_utils_1.buildAiHubDashboardPath());
        }
        else {
            updateTabInUrl('dashboard');
        }
    }, [activeUseCase, history, updateTabInUrl]);
    var handleAdminTabClick = react_1.useCallback(function (event) {
        event.preventDefault();
        updateTabInUrl('admin');
    }, [updateTabInUrl]);
    // Render a content-area loader (not a full-page one) while use cases load
    // for the dashboard / use-case-details route. The header/tabs stay visible
    // so the user keeps navigation context while switching tabs.
    var isDashboardLoading = shouldLoadUseCases && isLoadingUseCases && !useCases;
    var showUseCasesError = shouldLoadUseCases && !!useCasesError && !isLoadingUseCases;
    var showActiveImportBanner = isActiveImportStatus(activeImportRun === null || activeImportRun === void 0 ? void 0 : activeImportRun.status);
    return (react_1.default.createElement(demo_auth_context_1.DemoAuthProvider, null,
        react_1.default.createElement("div", { className: "ws-deliver-page ws-ai-hub-page" },
            react_1.default.createElement("div", { className: "ws-deliver-page-header ws-ai-hub-page-header" },
                react_1.default.createElement("div", { className: "ws-ai-hub-page-header-tabs tabs is-medium is-boxed" },
                    react_1.default.createElement("ul", null,
                        react_1.default.createElement("li", { className: "ws-ai-hub-page-header-tab" },
                            react_1.default.createElement(react_router_dom_1.NavLink, { to: "/deliver/decode" }, "Decode")),
                        react_1.default.createElement("li", { className: "ws-ai-hub-page-header-tab" },
                            react_1.default.createElement(react_router_dom_1.NavLink, { to: "/deliver/decode/digital-maturity" }, "Digital Maturity")),
                        react_1.default.createElement("li", { className: "ws-ai-hub-page-header-tab " + (tab === 'dashboard' ? 'is-active' : '') },
                            react_1.default.createElement("a", { href: "#!", onClick: handleUseCasesTabClick }, "Use Cases")),
                        react_1.default.createElement("li", { className: "ws-ai-hub-page-header-tab" },
                            react_1.default.createElement(react_router_dom_1.NavLink, { to: "/deliver/decode/agent" }, "Agent")),
                        react_1.default.createElement("li", { className: "ws-ai-hub-page-header-tab" },
                            react_1.default.createElement(react_router_dom_1.NavLink, { to: "/deliver/decode/insights" }, "Insights")),
                        react_1.default.createElement("li", { className: "ws-ai-hub-page-header-tab" },
                            react_1.default.createElement(react_router_dom_1.NavLink, { to: "/deliver/decode/admin" }, "Admin (Decode)"))),
                    activeUseCase && (react_1.default.createElement("div", { className: "ws-ai-hub-page-header-use-case" },
                        react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: "ChevronRight", className: "ws-ai-hub-page-header-use-case-separator" }),
                        react_1.default.createElement("h1", { className: "ws-ai-hub-page-header-use-case-title" },
                            activeUseCase.id && (react_1.default.createElement("span", { className: "ws-ai-hub-page-header-use-case-id", title: "Use case ID " + activeUseCase.id }, activeUseCase.id)),
                            activeUseCase.title)))),
                react_1.default.createElement("div", { className: "ws-ai-hub-page-header-tabs ws-ai-hub-page-header-tabs-right tabs is-medium is-boxed" },
                    react_1.default.createElement("ul", null,
                        react_1.default.createElement("li", { className: "ws-ai-hub-page-header-tab ws-ai-hub-page-header-admin-tab " + (tab === 'admin' ? 'is-active' : '') },
                            react_1.default.createElement("a", { href: "#!", onClick: handleAdminTabClick },
                                react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: "Settings", className: "ws-ai-hub-page-header-admin-tab-icon" }),
                                react_1.default.createElement("span", { className: "ws-ai-hub-page-header-admin-tab-label" }, "Admin")))))),
            react_1.default.createElement("div", { className: "ws-ai-hub-page-content" },
                showActiveImportBanner && activeImportRun && (react_1.default.createElement(MessageBar_1.MessageBar, { className: "ws-ai-hub-import-banner", messageBarType: MessageBar_1.MessageBarType.warning, isMultiline: false },
                    react_1.default.createElement("span", null,
                        "An import is in progress. Refresh to see latest status.",
                        ' ',
                        react_1.default.createElement("button", { type: "button", className: "ws-ai-hub-import-banner-link", onClick: function () { return setIsImportDetailsOpen(true); } }, "Details")))),
                showUseCasesError && (react_1.default.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.error }, "Could not load AI use cases. Please reload and try again.")),
                isDashboardLoading ? (react_1.default.createElement(AiHubLoadingState_1.AiHubLoadingState, { label: "Loading use cases..." })) : (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(AiHubLoadingState_1.AiHubLoadingState, { label: "Loading..." }) },
                    react_1.default.createElement(react_router_dom_1.Switch, null,
                        react_1.default.createElement(react_router_dom_1.Route, { path: USE_CASE_DETAILS_ROUTE },
                            react_1.default.createElement(WsAiHubUseCaseDetails, { useCases: useCases })),
                        react_1.default.createElement(react_router_dom_1.Route, { path: AI_HUB_ROUTE },
                            tab === 'dashboard' && useCases && (react_1.default.createElement(WsAiHubDashboard, { useCases: useCases, onRefresh: handleRefreshUseCases, isImportRunActive: showActiveImportBanner, onImportRunCreated: refreshActiveImportRun })),
                            tab === 'admin' && (react_1.default.createElement(WsAiHubAdmin, { location: location, history: history, currentUser: props.currentUser })))))),
                activeImportRun && (react_1.default.createElement(Dialog_1.Dialog, { hidden: !isImportDetailsOpen, onDismiss: function () { return setIsImportDetailsOpen(false); }, dialogContentProps: {
                        type: Dialog_1.DialogType.normal,
                        title: "Import Run #" + activeImportRun.id,
                    }, modalProps: {
                        isBlocking: false,
                    } },
                    react_1.default.createElement("div", { className: "ws-ai-hub-import-details" },
                        react_1.default.createElement("div", { className: "ws-ai-hub-import-details-row" },
                            react_1.default.createElement("strong", null, "Status:"),
                            " ",
                            formatImportRunLabel(activeImportRun.status)),
                        react_1.default.createElement("div", { className: "ws-ai-hub-import-details-row" },
                            react_1.default.createElement("strong", null, "Current Stage:"),
                            " ",
                            formatImportRunLabel(activeImportRun.currentStage)),
                        react_1.default.createElement("div", { className: "ws-ai-hub-import-details-row" },
                            react_1.default.createElement("strong", null, "Total Use Cases:"),
                            " ",
                            activeImportRun.totalUseCases),
                        react_1.default.createElement("div", { className: "ws-ai-hub-import-details-row" },
                            react_1.default.createElement("strong", null, "Processed:"),
                            " ",
                            activeImportRun.processedUseCases),
                        react_1.default.createElement("div", { className: "ws-ai-hub-import-details-row" },
                            react_1.default.createElement("strong", null, "Failed:"),
                            " ",
                            activeImportRun.failedUseCases),
                        react_1.default.createElement("div", { className: "ws-ai-hub-import-details-row" },
                            react_1.default.createElement("strong", null, "Started:"),
                            " ",
                            formatImportDateTime(activeImportRun.startedAt))),
                    react_1.default.createElement(Dialog_1.DialogFooter, null,
                        react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { text: "Close", onClick: function () { return setIsImportDetailsOpen(false); } }))))))));
};
exports.WsAiHubPage = WsAiHubPage;
